import {Block} from './Blocks'
import {CountryType} from '../layout/worldmap/RegionSelector'
import React from 'react'
import {SidebarCountryRegion} from '../layout/SidebarCountry'
import {style} from '../../util/style'

const styles = style('countryblock')

export type CountryBlockType = {
	type: 'country'
	country: CountryType
	continent: string
}

export const CountryBlock: React.FC<CountryBlockType & {sidebar?: boolean}> = ({
	sidebar,
	country,
	continent
}) => {
	if (!country || !country?.title) return null

	return (
		<Block className={styles()} sidebar={sidebar}>
			<SidebarCountryRegion country={country} continent={continent} />
		</Block>
	)
}
